// Post-submission redirect settings (survey-level: redirect_url,
// redirect_condition, redirect_delay_seconds). Shared by the Builder and the
// respondent/preview Thank You screen.
export const REDIRECT_CONDITIONS = [
  ['never', 'Never redirect'],
  ['always', 'Always redirect'],
  ['nps_9_10', 'Only if NPS® score is 9 or 10'],
  ['nps_7_8', 'Only if NPS® score is 7 or 8'],
  ['nps_0_6', 'Only if NPS® score is 0 to 6'],
  ['csat_4_5', 'Only if CSAT score is 4 or 5'],
  ['csat_1_3', 'Only if CSAT score is 1, 2 or 3'],
];

// Surveys saved before "Never redirect" existed have no condition stored:
// with a URL they always redirected, without one they never did.
export const effectiveRedirectCondition = (survey) =>
  survey?.redirect_condition || ((survey?.redirect_url || '').trim() ? 'always' : 'never');

export const redirectConditionLabel = (value) =>
  (REDIRECT_CONDITIONS.find(([v]) => v === value) || [null, value])[1];
